/* eslint camelcase: 0 */
import { Box, FormControl } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 0

export const ChipsContainerTrendsDescription = styled(Box)`
  display: flex;
  flex-flow: column wrap;
  position: relative;

  .chips-title {
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.normal};
    font-size: ${theme.typography.fontSize.large};
    letter-spacing: 0.1px;
    margin-bottom: ${theme.spacing.xSmall}px;
    white-space: nowrap;
    text-transform: capitalize;
    color: ${theme.colors.white};
    font-style: normal;
    line-height: 22px;
  }

  .MuiChip-root {
    background: transparent;
    border-radius: ${theme.attributes.borderRadius.secondary};
    border: 1px solid ${theme.colors.controlBorder};
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.bold};
    font-size: ${theme.typography.fontSize.medium};
    line-height: 16px;
    letter-spacing: 0.5px;
    color: ${theme.colors.white};
    text-transform: capitalize;

    &.selected {
      color: ${theme.baseColors.primary[20]};
      border: none;
      background: ${theme.colors.cta};
    }

    &:hover {
      background: ${theme.colors.cta};
      color: ${theme.baseColors.primary[20]} !important;
      opacity: 0.9 !important;
    }
  }

  .isopen {
    background: ${theme.colors.borderMedium};
    border-radius: 0 0 ${theme.attributes.borderRadius.tertiary} ${theme.attributes.borderRadius.tertiary};
    left: 185px;
    box-shadow: ${theme.attributes.boxShadow.navigation};
  }

  .month-picker-container {
    position: absolute;
    top: 148px;
    left: 185px;
    z-index: 10000;
    width: 420px;
    display: none;
    border-radius: ${theme.attributes.borderRadius.tertiary} ${theme.attributes.borderRadius.tertiary} 0 0;
    background: ${theme.colors.borderMedium};
    transition: opacity 313ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 208ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    box-shadow: ${theme.attributes.boxShadow.navigation};

    &.isopen {
      padding: 0;

      > div:first-of-type {
        padding: ${theme.spacing.small}px ${theme.spacing.md}px ${theme.spacing.half}px;
        justify-content: center;
        gap: 170px;

        & [class*='mx-4'] {
          &:before {
            width: 1px;
            height: 44px;
            background-color: #614964;
            position: absolute;
            left: 207.5px;
            top: 0;
            content: '';
            display: block;
          }
        }

        > div:first-of-type,
        > div:last-of-type {
          display: none;
        }
      }
    }

    p {
      color: ${theme.baseColors.greyscale[80]};
      text-align: center;
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.xLarge};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.bold};
      line-height: 24px;
      letter-spacing: 0.1px;
    }

    & [class*='gap-4'] {
      border-bottom: 1px solid #614964;

      > div:first-of-type {
        border-right: 1px solid #614964;
      }
    }

    .month-picker-month {
      color: #fbd8f5;
      text-align: center;
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.large};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.normal};
      line-height: 20px;
      letter-spacing: 0.25px;

      &[class*='variant-start'],
      &[class*='variant-end'] {
        background: ${theme.colors.cta};
        color: ${theme.baseColors.primary[20]};
      }

      &[class*='variant-selected'] {
        background: #614964;
        color: #fbd8f5;
      }

      &[class*='variant-selected'] {
        color: #fbd8f5;
      }

      &[class*='variant-default'] {
        &:hover {
          background: transparent;
        }
      }
    }

    &.isopen {
      display: flex;
    }

    html[data-theme='light'] & {
      background: ${theme.colors.surfaceContainerBackground};
      box-shadow: ${theme.colors.tooltipShadow};

      &.isopen > div:first-of-type [class*='mx-4']:before {
        background-color: ${theme.colors.strokePrimary};
      }

      p {
        color: ${theme.colors.foreground};
      }

      & [class*='gap-4'] {
        border-bottom-color: ${theme.colors.strokePrimary};

        > div:first-of-type {
          border-right-color: ${theme.colors.strokePrimary};
        }
      }

      .month-picker-month {
        color: ${theme.colors.foreground};

        &[class*='disabled-true'] {
          color: ${theme.colors.calendarDisabledDay};
          opacity: 1;
        }

        &[class*='variant-start'],
        &[class*='variant-end'] {
          background: ${theme.colors.cta};
          color: #ffffff;
        }

        &[class*='variant-selected'] {
          background: ${theme.colors.menuItemHover};
          color: ${theme.colors.foreground};
        }
      }
    }
  }
`

export const TrendsChartDescriptionFormControl = styled(FormControl)<{
  isselected?: string
  is_opened: string
  is_disabled: string
  noborder?: string
  autowidth?: string
}>`
  border: 1px solid ${theme.colors.legacyBorderLow2};
  background: transparent;
  outline: none;
  width: 131px;
  height: 48px;
  border-radius: ${theme.attributes.borderRadius.tertiary};

  html[data-theme='light'] & {
    background: ${theme.colors.surfaceContainerBackground};
  }

  ${({ autowidth }) =>
    autowidth === 'true' &&
    `
      width: auto;
      min-width: 131px;
  `};

  .MuiOutlinedInput-root {
    width: 100%;
    height: 48px;
    background: transparent;
    border: 0;
    color: ${theme.colors.cta};
    text-align: left;
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: 20px;
    letter-spacing: 0.1px;
    text-transform: capitalize;
    padding: 14px 51px 14px ${theme.spacing.small}px;
    cursor: pointer;
    text-overflow: ellipsis;
    overflow: hidden;

    .inline-filter-label {
      color: ${theme.colors.dropdownLabel};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.large};
      font-weight: ${theme.typography.fontWeight.bold};
      line-height: 20px;
      text-transform: none;
      margin-right: ${theme.spacing.xSmall}px;
      white-space: nowrap;

      html[data-theme='light'] & {
        color: ${theme.colors.textCaption};
      }
    }

    .MuiSelect-select {
      padding: 0 !important;
      color: ${theme.colors.cta};

      ${({ noborder }) =>
        noborder === 'true' &&
        `
          border-radius: 0;
          border: 0;
          border-color: transparent;
          background: transparent;
      `};

      ${({ isselected }) =>
        isselected === 'true'
          ? `
          color: ${theme.colors.cta} !important;
          
            .MuiOutlinedInput-root {
              .MuiSelect-select {
                color: ${theme.colors.cta} !important;
              }
            }
          `
          : `
            .MuiOutlinedInput-input {
              color: ${theme.colors.cta} !important;
            }
        `};

      > * {
        border: none !important;
        outline: none !important;
      }

      .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
        border: none !important;
      }
    }

    .MuiSelect-nativeInput {
      cursor: pointer;
    }

    svg {
      transition: all 0.5s ease-in-out;
      cursor: pointer;
      right: 16px;

      path {
        stroke: ${theme.colors.dropdownLabel};
      }
    }

    fieldset {
      outline: 0;
      border: 0;
    }
  }

  &:hover {
    .MuiOutlinedInput-root {
      color: ${theme.colors.cta};
    }

    svg {
      path {
        stroke: ${theme.colors.cta} !important;
      }
    }
  }

  ${({ is_disabled }) =>
    is_disabled &&
    is_disabled === 'true' &&
    `
      opacity: 0.38;
      pointer-events: none;
      cursor: default;
      
      &:hover {
        background: transparent;
    
        .MuiOutlinedInput-root {
          color: ${theme.colors.cta};
        }
      }
      
       .MuiOutlinedInput-root {
        color: ${theme.colors.cta};
      }
  `};

  ${({ is_opened }) =>
    is_opened &&
    is_opened === 'true' &&
    `
      border-color: ${theme.colors.cta} !important;
      outline: 0;
      
      .MuiOutlinedInput-root {
        color: ${theme.colors.cta};
      }
      
      svg {
        transform: rotate(180deg);

        path {
          stroke: ${theme.colors.cta} !important;
        }
      }
  `};

  ${({ isselected }) =>
    isselected &&
    isselected === 'true' &&
    `
    background: rgba(234, 221, 255, 0.08);
    color: ${theme.colors.cta} !important;
    border-color: ${theme.colors.cta} !important;
    
    .MuiOutlinedInput-root {
      border-color: ${theme.colors.cta} !important;
    }
  `};
`

export const CategoryMenuProps = {
  PaperProps: {
    sx: {
      marginTop: `${theme.spacing.xSmall}px`,
      background: theme.colors.menuBg,
      boxShadow: theme.attributes.boxShadow.navigation,
      borderRadius: theme.attributes.borderRadius.tertiary,
      minWidth: '144px',
      width: '144px',
      padding: 0,

      '.MuiList-root': {
        padding: 0
      },

      '.MuiMenuItem-root': {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        minWidth: '144px',
        height: '48px',
        padding: `${theme.spacing.sm}px ${theme.spacing.small}px`,

        '&:first-of-type': {
          paddingTop: '16px'
        },

        '&:last-of-type': {
          paddingBottom: '16px'
        },

        img: {
          marginRight: `${theme.spacing.xSmall}px`
        },

        '& > svg path': {
          stroke: theme.colors.cta
        },

        '&:hover': {
          background: theme.colors.menuItemHover,

          '.MuiListItemText-root .MuiTypography-root': {
            color: `${theme.colors.cta}`
          }
        },

        '.MuiCheckbox-root': {
          marginRight: `${theme.spacing.xSmall}px`,

          '&.Mui-checked': {
            svg: {
              path: {
                fill: theme.colors.cta
              }
            }
          },

          '&:hover': {
            borderRadius: theme.attributes.borderRadius.large,
            background: 'rgba(202, 196, 208, 0.12)'
          },

          svg: {
            width: '18px',
            height: '18px',

            path: {
              fill: theme.baseColors.greyscale[80]
            }
          }
        },

        '.MuiListItemText-root .MuiTypography-root': {
          fontFamily: theme.typography.fontFamily.primary,
          fontWeight: theme.typography.fontWeight.bold,
          fontSize: theme.typography.fontSize.large,
          color: theme.colors.menuItemText,
          lineHeight: '22px',
          fontStyle: 'normal',
          textTransform: 'capitalize',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden'
        },

        '&.Mui-selected': {
          background: `${theme.colors.legacySurfaceContainerBackground2}`
        },

        '&[aria-selected="true"]': {
          '.MuiListItemText-root .MuiTypography-root': {
            color: `${theme.colors.cta}`
          }
        },

        "html[data-theme='light'] &": {
          '&:hover .MuiListItemText-root .MuiTypography-root': {
            color: theme.colors.menuItemText
          },

          '&.Mui-selected, &.Mui-selected:hover': {
            background: '#f8ecf3'
          },

          '&[aria-selected="true"] .MuiListItemText-root .MuiTypography-root': {
            color: theme.colors.cta
          }
        }
      },

      '&::-webkit-scrollbar': {
        width: '4px',
        background: 'transparent'
      },

      '&::-webkit-scrollbar-track': {
        boxShadow: 'none',
        background: 'transparent'
      },

      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#FBD8F5',
        borderRadius: theme.attributes.borderRadius.secondary
      },

      "html[data-theme='light'] &::-webkit-scrollbar-thumb": {
        backgroundColor: theme.colors.borderMedium
      }
    },
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP
    }
  },
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'left' as const
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'left' as const
  },
  variant: 'menu' as const
}
